export default __webpack_public_path__ + "static/SlymeOrig-1944ab55dcb7f04b081ef4ccbbe513c3.jpg";